import { useMemo } from 'react';
import { Account } from '../sp-types/accountTypes';
import { useAccountStore } from '../components/Stores/accountStore';

/**
 * Get the custom term for the Demand category with fallback to default
 */
export const getDemandTerm = (account?: Account): string => {
  return account?.demandTerm || 'Demand';
};

/**
 * Get the custom term for the Supply category with fallback to default
 */
export const getSupplyTerm = (account?: Account): string => {
  return account?.supplyTerm || 'Supply';
};

/**
 * Get the custom term for the Hedges category with fallback to default
 */
export const getHedgeTerm = (account?: Account): string => {
  return account?.hedgeTerm || 'Hedges';
};

/**
 * Get all three custom terms as an object
 */
export const getCategoryTerms = (account?: Account) => ({
  demand: getDemandTerm(account),
  supply: getSupplyTerm(account),
  hedge: getHedgeTerm(account),
});

/**
 * Hook: returns the custom category terms for the active account.
 * Reactive — updates when superadmins switch accounts.
 */
export const useCategoryTerms = () => {
  const { account } = useAccountStore();
  return useMemo(() => ({
    demand: account?.demandTerm || 'Demand',
    supply: account?.supplyTerm || 'Supply',
    hedge: account?.hedgeTerm || 'Hedges',
  }), [account?.demandTerm, account?.supplyTerm, account?.hedgeTerm]);
};
